import { createFileRoute, Outlet } from "@tanstack/react-router";

// Pathless layout for /o/$slug/notes/* — gives both the list (notes/) and the
// detail (notes/$noteId) a common parent without forcing them into a single
// component. Auth + org context come from the /o/$slug parent.
export const Route = createFileRoute("/o/$slug/notes")({
  component: () => <Outlet />,
});
